<template>
  <div class="com-topic-tag" :style="labelWidth" ref="topic" :data-label="label">
    <template v-if="label && !list.length">
      <span class="no-topic">暂无相关频道</span>
    </template>
    <template v-else>
      <TopicTitle
        v-for="tag in topicList"
        class="topic-tag-title"
        :style="tagSpace"
        :id="tag.alias || tag.id"
        :title="tag.name"
        :key="tag.id"
      />
    </template>
    
  </div>
</template>

<script>
import VueTypes from 'vue-types'
import TopicTitle from '../title/TopicTitle'

/**
 * 频道列表
 * @desc 无数据时显示 “暂无相关频道”，有数据显示多个 TopicTitle
 * @module component/TopicTag
 * @extend TopicTitle
 * @example
 * <TopicTag :list="topicList" />
 * <TopicTag :list="topicList" label="相关频道：" left="70"/>
 */
export default {
  name: 'topic-tag',
  components: {
    TopicTitle
  },
  /**
   * 传入数据
   * @property {String}         label       频道列表的前置文案
   * @property {String|Number}  left        频道介绍的宽度
   * @property {String|Number}  space       每项频道的间隔
   * @property {Array<Object>}  list        频道列表
   * @property {String}         list.alias  频道别名
   * @property {Number}         list.id     频道 ID
   * @property {String}         list.name   频道名称
   */
  props: {
    label: VueTypes.string.def(''),
    left: VueTypes.oneOfType([Number, String]).def(0),
    space: VueTypes.oneOfType([Number, String]).def(8),
    list: VueTypes.arrayOf(Object).def([])
  },
  /**
   * 内部属性
   * @member
   * @property {Number} topicWidth  可显示所有频道的宽度
   */
  data () {
    return {
      topicWidth: 0
    }
  },
  computed: {
    /**
     * 频道介绍宽度样式
     */
    labelWidth () {
      return {
        'padding-left': `${(parseInt(this.left) | 0)}px`
      }
    },
    /**
     * 每项频道间隔样式
     */
    tagSpace () {
      return {
        'margin-right': `${(parseInt(this.space) | 0)}px`
      }
    },
    /**
     * 频道列表
     * 根据使用方式和总宽度，计算可展示的频道数量
     * 每个字: 12px, 标签 padding: 12px
     */
    topicList () {
      const topic = []
      const space = 12 + (parseInt(this.space) | 0)

      Array.isArray(this.list) && this.list.reduce((width, item) => {
        if (width + item.name.length * 12 + space < this.topicWidth) {
          topic.push(item)

          return width + item.name.length * 12 + space
        }

        return width
      }, 0)

      return topic
    }
  },
  mounted () {
    // 计算总共频道标签的区域
    this.topicWidth = this.$refs.topic.clientWidth - (parseInt(this.left) | 0)
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/common';

.com-topic-tag {
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;

  &:before {
    position: absolute; left: 0; top: 0;
    content: attr(data-label);
    line-height: 18px;
    @include font(12, 400);
    color: $gray;
  }

  & > .topic-tag-title {
    display: block;
    padding: 0 8px;
    background: $lightBlue;
    border-radius: 18px;
    line-height: 18px;
    @include font(12, 400);
    color: $blue;
    // color: #1F6BB5;
    // @extend %animateBackgroundGrayHoverBlue;
    @extend %transition;
    user-select: none;

    &:hover {
      background: #C2D8F0;
    }

    &:last-child {
      margin-right: 0!important;
    }
  }

  & .no-topic {
    line-height: 18px;
    @include font(12, 400);
    color: $gray;
  }
}

</style>
